class Environment {
  // Auth constants
  /** Auth constant for OAuth */
  clientID = process.env.REACT_APP_CLIENT_ID
    ? process.env.REACT_APP_CLIENT_ID
    : 'client_fm9k6e04frv42les69bla6fate';
  /** Auth constant for OAuth */
  clientSecret = process.env.REACT_APP_CLIENT_SECRET
    ? process.env.REACT_APP_CLIENT_SECRET
    : 'nhvf9t24re998o7os1aoehucuk';

  // Backend constant
  /** Backend constant @default hostname */
  backendHost = process.env.REACT_APP_BACKEND_HOST || window.location.hostname;
  /** Backend constant @default protocol */
  backendProto =
    process.env.REACT_APP_BACKEND_PROTOCOL || window.location.protocol;
  /** Backend constant @default port */
  backendPort = process.env.REACT_APP_BACKEND_PORT || window.location.port;
  /** Backend constant composed with `hostname` `port` and `protocol` */
  backendServiceUrl = `${this.backendProto}//${this.backendHost}${
    this.backendPort ? ':' + this.backendPort : ''
  }`;

  /** Backend API end points */

  backendAPIAuth = process.env.REACT_APP_BACKEND_API_AUTH || '/api/auth';
  backendAPIAlarms = process.env.REACT_APP_BACKEND_API_ALARMS || '/api/alarm';
  backendAPIConfig = process.env.REACT_APP_BACKEND_API_DEVCFG || '/api/config';
  backendAPICommander =
    process.env.REACT_APP_BACKEND_API_COMMANDER || '/api/commander';
  backendAPIEvents =
    process.env.REACT_APP_BACKEND_API_EVENTPERSISTENCE || '/api/event';
  backendAPIFlexeServe =
    process.env.REACT_APP_BACKEND_API_FLEXESERVE || '/api/flexeserve';

  backendAPIGroups = process.env.REACT_APP_BACKEND_API_GROUPS || '/api/groups';
  backendAPIRights = process.env.REACT_APP_BACKEND_API_RIGHTS || '/api/rights';
  backendAPIUpdate = process.env.REACT_APP_BACKEND_API_UPDATE || '/api/update';
  backendAPIStatus =
    process.env.REACT_APP_BACKEND_API_DEVSTATUS || '/api/devicestate';
  backendAPIUser = process.env.REACT_APP_BACKEND_API_USER || '/api/user';
  backendAPIUserSettings =
    process.env.REACT_APP_BACKEND_API_USERSETTINGS || '/api/user/settings';
  backendAPIWorkspace =
    process.env.REACT_APP_BACKEND_API_WORKSPACEMANAGEMENT || '/api/workspace';
  backendAPIReports =
    process.env.REACT_APP_BACKEND_API_REPORTS || '/api/report';
  backendAPIBilling =
    process.env.REACT_APP_BACKEND_API_BILLING || '/api/billing';
  backendAPITranslation =
    process.env.REACT_APP_BACKEND_API_TRANSLATIONS || '/api/translation';
  backendAPIFlexeServeOperator =
    process.env.REACT_APP_BACKEND_API_FLEXESERVE_OPERATOR ||
    '/api/flexeserve/operator';
  backendAPISensors =
    process.env.REACT_APP_BACKEND_API_SENSORDATAPERSISTENCE ||
    '/api/sensordata';
  get backendURL() {
    return this.backendServiceUrl;
  }

  // Storage constants
  authInfoKey = 'auth_info';
  authInfoManagerKey = 'auth_manager_info';
}

export default new Environment();
